import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationsService } from 'src/app/applications/applications.service';
import {CdkStepper} from '@angular/cdk/stepper';

@Component({
  selector: 'app-apply-senior-confirm',
  templateUrl: './apply-senior-confirm.component.html',
  styleUrls: ['./apply-senior-confirm.component.scss']
})
export class ApplySeniorConfirmComponent implements OnInit {
  @Input() cdkStepper: CdkStepper;

  constructor(public applicationService: ApplicationsService, public modalService: NgbModal, public activeModal: NgbActiveModal, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    // this.applicationService.application.fundingBucket = 'BURSARY';
  }

  close() {
    this.modalService.dismissAll();
  }

  moveToParentsPage() {
    this.cdkStepper.next();
    this.activeModal.dismiss();
  }

}
